import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { TimeService } from 'src/app/time.service';
import { DateTime, Duration } from 'luxon';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from 'src/app/snackbar.service';
import { HttpService } from 'src/app/http.service';


@Component({
  selector: 'app-holidays-list',
  templateUrl: './holidays-list.component.html',
  styleUrls: ['./holidays-list.component.scss']
})
export class HolidaysListComponent implements OnInit {

  holiday_date:any = {
    date:'',
    date_ts:''
  };
  holiday_description = '';
  holidays = [];
  showLoader = false;

  constructor(private dialog: MatDialogRef<HolidaysListComponent>,private translate: TranslateService,private http:HttpService,
     private snackbar: SnackbarService,@Inject(MAT_DIALOG_DATA) public parentData: any,private timeService: TimeService) { }

  ngOnInit() {
    if(this.parentData.length){
      this.holidays = this.parentData;
    }else if(this.parentData.element){
      this.holidays = this.parentData.holidays;
      this.holiday_description = this.parentData.element.holiday;
      this.holiday_date.date = this.parentData.element.date_;
      this.holiday_date.date_ts = DateTime.fromJSDate(this.parentData.element.date_).toFormat('yyyy-MM-dd')
    }
  }

  setHolidayDate(value){
    const t2: any = DateTime.fromJSDate(value.date).toFormat('yyyy-MM-dd');
    this.holiday_date.date_ts = t2;
  }

  updateHoliday(){
    let holidays = this.holidays.map( (holiday) => {
      let date =new Date(holiday.year,(holiday.month - 1),holiday.day);
      const t2: any = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
      let holiday_date:any = t2;
      return {
        name:holiday.name,
        date:holiday_date
      }
    })

    let holiday = {
      name:this.holiday_description,
      date:this.holiday_date.date_ts
    }
    holidays.push(holiday);
    const payload = {
      holidays:holidays
    }

    if(!holiday.date || !this.holiday_date.date){
      this.snackbar.openSnackBar(this.translate.instant('MESSAGE.HOLIDAY_LIST.VALIDATION.HOLIDAY_DATE'), '', 'err');
      return;
    }else if(!holiday.name){
      this.snackbar.openSnackBar(this.translate.instant('MESSAGE.HOLIDAY_LIST.VALIDATION.HOLIDAY_DESC'), '', 'err');
      return;
    }else{
      this.showLoader = true;
      this.http.post('fleet_settings/holidays',payload,3).subscribe((response:any)=>{
        if(response.statusCode == 200){
          this.showLoader = false;
          if(!this.parentData.element){
            this.snackbar.openSnackBar(this.translate.instant('MESSAGE.HOLIDAY_LIST.SUCCESS.HOLIDAY'));
          }else{
            this.snackbar.openSnackBar(this.translate.instant('MESSAGE.CONFIRMATION_MODAL.SUCCESS.EDIT_HOLIDAY'));
          }
          this.closeDialog(response);
        }
      },
      (err)=>{
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      })
    }

  }

  closeDialog(data:any = {}){
    this.holiday_description = '';
    this.holiday_date.date_ts = '';
    this.holiday_date.date = '';
    this.dialog.close(data);
  }

}
